module.exports = __webpack_public_path__ + "img/2020_1_24.410eaf13.jpg";